import { __decorate } from "tslib";
import { Vue, Component, Prop } from 'vue-property-decorator';
let BaseText = class BaseText extends Vue {
    styles() {
        return {
            'font-weight-thin': this.thin,
            'font-weight-light': this.light,
            'font-weight-regular': this.regular,
            'font-weight-medium': this.medium,
            'font-weight-bold': this.bold,
            'font-weight-black': this.bolder,
            'font-italic': this.italic,
            '-heading-1': this.heading1,
            '-heading-2': this.heading2,
            '-heading-3': this.heading3,
            '-navigation': this.navigation,
            '-card-text': this.cardText,
            '-text-grey': this.textGrey,
            '-text-grey-light-1': this.textGreyLight1,
            '-text-grey-light-3': this.textGreyLight3,
            '-text-primary': this.textBlue,
            '-text-white': this.textWhite,
            '-caption': this.caption,
            '-footer': this.footer,
            '-heading-mobile-1': this.headingMobile1,
            '-mobile': this.mobile,
            '-heading-mobile-3': this.headingMobile3,
            '-card-title-mobile': this.cardTitleMobile,
            '-hover': this.onHover,
            '-dark-blue': this.textDarkBlue,
            '-footer-mobile': this.footerMobile,
            '-font-size-10': this.fontSize10,
            '-font-size-12': this.fontSize12,
            '-font-size-14': this.fontSize14,
            '-font-size-16': this.fontSize16,
            '-line-height-11': this.lineHeight11,
            '-line-height-14': this.lineHeight14,
            '-line-height-16': this.lineHeight16,
            '-line-height-19': this.lineHeight19,
            '-line-height-20': this.lineHeight20,
            '-text-dark-grey': this.textDarkGrey,
            '-roboto-medium': this.robotoMedium,
            '-font-size-18': this.fontSize18,
            '-text-orange': this.textOrange,
            '-text-dark-blue-2': this.textDarkBlue2,
            '-text-light-green': this.textLightGreen,
            '-text-light-green-4': this.textLightGreen4,
            '-no-width': this.noWidth,
            '-margin-right-10': this.marginRight10,
            '-centered': this.centered,
            '-text-grey-light-15': this.textGreyLight15,
            '-text-error-message': this.textErrorMessage,
            '-word-break': this.wordBreak,
            '-margin-bottom-0': this.marginBottom0
        };
    }
};
__decorate([
    Prop({ type: String, required: true })
], BaseText.prototype, "text", void 0);
__decorate([
    Prop({ type: Boolean, default: false })
], BaseText.prototype, "thin", void 0);
__decorate([
    Prop({ type: Boolean, default: false })
], BaseText.prototype, "light", void 0);
__decorate([
    Prop({ type: Boolean, default: false })
], BaseText.prototype, "regular", void 0);
__decorate([
    Prop({ type: Boolean, default: false })
], BaseText.prototype, "medium", void 0);
__decorate([
    Prop({ type: Boolean, default: false })
], BaseText.prototype, "bold", void 0);
__decorate([
    Prop({ type: Boolean, default: false })
], BaseText.prototype, "bolder", void 0);
__decorate([
    Prop({ type: Boolean, default: false })
], BaseText.prototype, "italic", void 0);
__decorate([
    Prop({ type: Boolean, default: false })
], BaseText.prototype, "heading1", void 0);
__decorate([
    Prop({ type: Boolean, default: false })
], BaseText.prototype, "heading2", void 0);
__decorate([
    Prop({ type: Boolean, default: false })
], BaseText.prototype, "heading3", void 0);
__decorate([
    Prop({ type: Boolean, default: false })
], BaseText.prototype, "navigation", void 0);
__decorate([
    Prop({ type: Boolean, default: false })
], BaseText.prototype, "cardText", void 0);
__decorate([
    Prop({ type: Boolean, default: false })
], BaseText.prototype, "textGrey", void 0);
__decorate([
    Prop({ type: Boolean, default: false })
], BaseText.prototype, "textGreyLight1", void 0);
__decorate([
    Prop({ type: Boolean, default: false })
], BaseText.prototype, "textGreyLight3", void 0);
__decorate([
    Prop({ type: Boolean, default: false })
], BaseText.prototype, "textGreyLight15", void 0);
__decorate([
    Prop({ type: Boolean, default: false })
], BaseText.prototype, "textBlue", void 0);
__decorate([
    Prop({ type: Boolean, default: false })
], BaseText.prototype, "textWhite", void 0);
__decorate([
    Prop({ type: Boolean, default: false })
], BaseText.prototype, "caption", void 0);
__decorate([
    Prop({ type: Boolean, default: false })
], BaseText.prototype, "footer", void 0);
__decorate([
    Prop({ type: Boolean, default: false })
], BaseText.prototype, "headingMobile1", void 0);
__decorate([
    Prop({ type: Boolean, default: false })
], BaseText.prototype, "headingMobile3", void 0);
__decorate([
    Prop({ type: Boolean, default: false })
], BaseText.prototype, "mobile", void 0);
__decorate([
    Prop({ type: Boolean, default: false })
], BaseText.prototype, "cardTitle", void 0);
__decorate([
    Prop({ type: Boolean, default: false })
], BaseText.prototype, "cardTitleMobile", void 0);
__decorate([
    Prop({ type: Boolean, default: false })
], BaseText.prototype, "textDarkBlue", void 0);
__decorate([
    Prop({ type: Boolean, default: false })
], BaseText.prototype, "footerMobile", void 0);
__decorate([
    Prop({ type: Boolean, default: false })
], BaseText.prototype, "fontSize10", void 0);
__decorate([
    Prop({ type: Boolean, default: false })
], BaseText.prototype, "fontSize14", void 0);
__decorate([
    Prop({ type: Boolean, default: false })
], BaseText.prototype, "fontSize16", void 0);
__decorate([
    Prop({ type: Boolean, default: false })
], BaseText.prototype, "lineHeight11", void 0);
__decorate([
    Prop({ type: Boolean, default: false })
], BaseText.prototype, "lineHeight16", void 0);
__decorate([
    Prop({ type: Boolean, default: false })
], BaseText.prototype, "lineHeight19", void 0);
__decorate([
    Prop({ type: Boolean, default: false })
], BaseText.prototype, "lineHeight20", void 0);
__decorate([
    Prop({ type: Boolean, default: false })
], BaseText.prototype, "fontSize12", void 0);
__decorate([
    Prop({ type: Boolean, default: false })
], BaseText.prototype, "lineHeight14", void 0);
__decorate([
    Prop({ type: Boolean, default: false })
], BaseText.prototype, "textDarkGrey", void 0);
__decorate([
    Prop({ type: Boolean, default: false })
], BaseText.prototype, "robotoMedium", void 0);
__decorate([
    Prop({ type: Boolean, default: false })
], BaseText.prototype, "onHover", void 0);
__decorate([
    Prop({ type: Boolean, default: false })
], BaseText.prototype, "fontSize18", void 0);
__decorate([
    Prop({ type: Boolean, default: false })
], BaseText.prototype, "textOrange", void 0);
__decorate([
    Prop({ type: Boolean, default: false })
], BaseText.prototype, "noWidth", void 0);
__decorate([
    Prop({ type: Boolean, default: false })
], BaseText.prototype, "marginRight10", void 0);
__decorate([
    Prop({ type: Boolean, default: false })
], BaseText.prototype, "centered", void 0);
__decorate([
    Prop({ type: Boolean, default: false })
], BaseText.prototype, "textDarkBlue2", void 0);
__decorate([
    Prop({ type: Boolean, default: false })
], BaseText.prototype, "textLightGreen", void 0);
__decorate([
    Prop({ type: Boolean, default: false })
], BaseText.prototype, "textLightGreen4", void 0);
__decorate([
    Prop({ type: Boolean, default: false })
], BaseText.prototype, "textErrorMessage", void 0);
__decorate([
    Prop({ type: Boolean, default: false })
], BaseText.prototype, "wordBreak", void 0);
__decorate([
    Prop({ type: Boolean, default: false })
], BaseText.prototype, "marginBottom0", void 0);
BaseText = __decorate([
    Component
], BaseText);
export default BaseText;
